import { isBrowser } from 'app/infrastructure/universal';

/**
 * Resolve client platform and browser info without intepretations
 */
export function clientInfo() {

  if (!isBrowser) {
    return { platform: 'node' };
  }

  try {
  
    let { platform, userAgent, cookieEnabled, onLine, language, languages, userLanguage} = (navigator as any); // tslint:disable-line

    return {
      browser: userAgent,
      cookieEnabled,
      language: { language, languages, userLanguage },
      platform,
      timezone: new Date().getTimezoneOffset(),
      online: onLine,
      url: window.location.href
    };

  } catch (err) {
    console.error('Failed to obtain client info', err.message);
    return {};
  }
}
